import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    selectors: {
      '.ms-Dialog-title': {
        paddingTop: pxToRem(32),
        paddingBottom: pxToRem(8),
      },
      '.ms-Dialog-inner': {
        paddingBottom: pxToRem(32),
      },
      '.ms-Dialog-actions': {
        marginTop: pxToRem(24),
      },
    },
  },
  textFieldMessage: {
    background: 'transparent',
    marginTop: pxToRem(8),
    selectors: {
      '.ms-MessageBar-icon': {
        marginLeft: 0,
      },
      '.ms-MessageBar-text': {
        marginRight: 0,
      },
    },
  },
});
